import { DeleteAndArchiveDeliveredGatherRequestBody, GetAllInProcessGathersRequestParameter } from "../../common/model/gtr/requestBody";
import { GetAllInProcessGatherResponseBody } from "../../common/model/gtr/responseBody";
import { GTR_DeleteDelivered_Parameter, GTR_inProcessGather_Parameter } from "../apiParameters";
import { baseResponseBody } from "../objectTypeConstants";

export const deleteAndArchiveDeliveredGatherRequestBody: DeleteAndArchiveDeliveredGatherRequestBody = {
    gatherId: GTR_DeleteDelivered_Parameter.gatherId,
    correlationId: GTR_DeleteDelivered_Parameter.correlationId,
    callbackUri: GTR_DeleteDelivered_Parameter.callbackUri,
}

export const deleteInProcessGathersRequestBody = {...deleteAndArchiveDeliveredGatherRequestBody}

export const getAllInProcessGathersRequestParameter: GetAllInProcessGathersRequestParameter = {
    clientNameQuery: GTR_inProcessGather_Parameter.clientNameQuery,
    clientIdQuery: GTR_inProcessGather_Parameter.clientIdQuery,
    taxYearQuery: GTR_inProcessGather_Parameter.taxYearQuery,
    eroSignerQuery: GTR_inProcessGather_Parameter.eroSignerQuery,
    engagementTypeQuery: GTR_inProcessGather_Parameter.engagementTypeQuery,
    documentStatusQuery: GTR_inProcessGather_Parameter.documentStatusQuery,
    pageSizeQuery: GTR_inProcessGather_Parameter.pageSizeQuery,
    pageNumberQuery: GTR_inProcessGather_Parameter.pageNumberQuery,
    sortByQuery: GTR_inProcessGather_Parameter.sortByQuery,
    sortOrderQuery: GTR_inProcessGather_Parameter.sortOrderQuery,
}

export const getAllInProcessGatherResponseBody: GetAllInProcessGatherResponseBody = {
    ...baseResponseBody,
    data: {
        clientName: GTR_inProcessGather_Parameter.clientName,
        clientId: GTR_inProcessGather_Parameter.clientId,
        eroSigner: GTR_inProcessGather_Parameter.eroSigner,
        officeLocation: GTR_inProcessGather_Parameter.officeLocation,
        assignedTo: GTR_inProcessGather_Parameter.assignedTo,
        status: GTR_inProcessGather_Parameter.status,
        date: GTR_inProcessGather_Parameter.date,
        engagementType: GTR_inProcessGather_Parameter.engagementType,
        taxYear: GTR_inProcessGather_Parameter.taxYear,
        gatherId: GTR_inProcessGather_Parameter.gatherId,
    }
}